import { useNavigate } from 'react-router-dom';
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useDispatch } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ENTITY_IS_IN_USE_MESSAGE, EXCEL_VALIDATION_MESSAGE } from '../../utils/constants';
import { GoPlus } from 'react-icons/go';
import Button from '../../components/Button';
import Input from '../../components/Input';
import { formatNumber, onChange } from '../../utils/functions';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import DeleteModal from '../../components/DeleteModal';
import { OUTSOURCER_PATH, deleteOutsourcer, downloadOutsourcerExcelFile, downloadOutsourcerReceipt, getPageOutsourcers, uploadOutsourcerExcelFile } from '../../api/outsourcerApi';
import readXlsxFile, { readSheetNames } from 'read-excel-file';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { pageModel } from '../../utils/model';
import { MdPayments } from 'react-icons/md';
import { IoReceiptSharp } from 'react-icons/io5';
import OutsourcerReceipt from '../../components/outsourcer/OutsourcerReceipt';

const OutsourcerListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [outsourcerPage, setOutsourcerPage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${OUTSOURCER_PATH}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${OUTSOURCER_PATH}`, false)
    const [searchParams, setSearchParams] = useState({
        id: "",
        code: "",
        name: ""
    })
    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();
    const [isOpenReceiptModal, setIsOpenReceiptModal] = useState(false)
    const [receiptOutsourcer, setReceiptOutsourcer] = useState()

    useEffect(() => {
        loadOutsourcers({ size: 20, page: outsourcerPage.number, ...searchParams })
    }, [])

    const onLoadMore = () => {
        if (!outsourcerPage.last) {
            loadOutsourcers({ ...searchParams, lastId: outsourcerPage.content[outsourcerPage.content.length - 1]?.id })
        }
    }

    useEffect(() => {
        !isFirstRender && searching(searchParams)
    }, [searchParams])

    const loadOutsourcers = (params) => {
        !pendingApiCall &&
            getPageOutsourcers(params)
                .then(res => {
                    setOutsourcerPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageOutsourcers(params)
                .then(res => {
                    setOutsourcerPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickDelete = () => {
        deleteOutsourcer(deleteId)
            .then(res => {
                setIsOpen(false)
                setOutsourcerPage(prevState => ({ ...prevState, content: prevState.content.filter(c => c.id !== res.data.id) }))
                toast.success('Silindi')
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    const uploadExcelFile = async (event) => {
        const file = event.target.files[0];
        if (!Boolean(file)) return;
        const sheets = await readSheetNames(file);
        let rows;
        for (const sheet of sheets) {
            rows = await readXlsxFile(file, { sheet });
            rows.shift();
        }
        const items = []
        for (const row of rows) {
            items.push({
                code: row[0],
                name: row[1],
                phone: row[2],
                address: row[3],
                currency: row[4],
                description: row[5]
            })
        }
        uploadOutsourcerExcelFile(items)
            .then(res => {
                setOutsourcerPage({ ...pageModel, content: res.data })
                toast.success("Kayıtlar yüklendi")
            }).catch(err => {
                toast.error(EXCEL_VALIDATION_MESSAGE)
            })
    }

    const downloadExcelFile = () => {
        downloadOutsourcerExcelFile().then(res => {
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'fasoncular.xlsx';
            a.click();
            window.URL.revokeObjectURL(url);
        }).catch(err => {
            toast.error('Dosya indirilirken hata oluştu!')
        })
    }

    const onClickDownloadReceipt = (firstDate, lastDate) => {
        downloadOutsourcerReceipt(receiptOutsourcer.id, firstDate, lastDate)
            .then(res => {
                const blob = new Blob([res.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Detaysız Ekstre - ${receiptOutsourcer.name}`;
                a.click();
                window.URL.revokeObjectURL(url);
            }).catch(err => {
                toast.error('Dosya indirilirken hata oluştu!')
            })
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl'>
                    FASONCULAR
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Fasoncu</label>}
                    variant='green'
                    onClick={() => nav('/outsourcer/add')}
                />
                {/* <label
                    className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                    htmlFor='excel-upload'
                >
                    <RiFileExcel2Fill />
                    <span> Excel Yükle</span>
                </label> */}
                <label
                    className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                    htmlFor='excel-download'
                    onClick={downloadExcelFile}
                >
                    <FaCloudDownloadAlt />
                    <span> Excel İndir</span>
                </label>
                {/* <input className='hidden' id='excel-upload' type='file' accept='.xls, .xlsx' onChange={e => uploadExcelFile(e)} /> */}
            </div>
            <table className='w-full text-left text-zinc-900 mb-10'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50 items-center'>
                    <tr>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-1/12'>Fas. Kodu</th>
                        <th className='p-2 w-3/12'>Fasoncu Adı</th>
                        <th className='p-2 w-1/24'>Kur</th>
                        {/* <th className='p-2 w-1/12'>Telefon</th> */}
                        <th className='p-2 w-2/12'>Borç</th>
                        <th className='p-2 w-2/12'>Alacak</th>
                        <th className='p-2 w-2/12'>Bakiye</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-20 bg-zinc-50'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="code"
                                placeholder='Fasoncu kodu...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="name"
                                placeholder='Fasoncu adı...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                    </tr>
                    {
                        outsourcerPage.content.map((outsourcer, index) => (
                            <tr key={index} className='border-b items-center text-sm items-center hover:bg-violet-100 duration-150'>
                                <td className='p-2'># {outsourcer.id} </td>
                                <td className='p-2'>{outsourcer.code} </td>
                                <td className='p-2'>{outsourcer.name}</td>
                                <td className='p-2'>{outsourcer.currency}</td>
                                {/* <td className='p-2'>{outsourcer.phone}</td> */}
                                <td className='p-2'>{formatNumber(outsourcer.debt)} {outsourcer.currency}</td>
                                <td className='p-2'>{formatNumber(outsourcer.credit)} {outsourcer.currency}</td>
                                <td className='p-2'>{formatNumber(outsourcer.balance)} {outsourcer.currency}</td>
                                <td className='p-2 items-center'>
                                    <div className='flex gap-x-3'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/outsourcer/edit/${outsourcer.id}`)}>
                                            <AiFillEdit />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                            onClick={() => {
                                                setIsOpen(true)
                                                setDeleteId(outsourcer.id)
                                            }}
                                        >
                                            <AiFillDelete />

                                        </span>
                                        <span className='cursor-pointer hover:scale-125 hover:text-green-600 duration-150' onClick={() => nav(`/outsourcer/${outsourcer.id}/payment`)}>
                                            <MdPayments />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-zinc-600 duration-150'
                                            onClick={() => {
                                                setReceiptOutsourcer(outsourcer)
                                                setIsOpenReceiptModal(true)
                                            }}
                                        >
                                            <IoReceiptSharp />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={outsourcerPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDelete}
                pendingApiCall={pendingApiCallDelete}
            />
            <OutsourcerReceipt
                isOpen={isOpenReceiptModal}
                closeModal={() => setIsOpenReceiptModal(false)}
                onClick={(firstDate, lastDate) => onClickDownloadReceipt(firstDate, lastDate)}
            />
        </div >
    )
}

export default OutsourcerListPage